var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w-4 h-4 flex flex-row center-x center-y border bg-white border-gray-400 rounded",on:{"click":_vm.addToInviteList}},[(_vm.value)?_c('IconCheck20',{staticClass:"text-gray-800"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }